import { Box, Container } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Text from 'commons/Text';

import useStyles from './style';

const TermsAndConditions = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  // mảng bullet points
  const points = t('terms.points', { returnObjects: true });
  // liability
  const liabilityTitle = t('terms.liability.title');
  const liabilityText = t('terms.liability.text');

  return (
    <Box className={classes.wrapper}>
      <Container disableGutters>
        <Box className={classes.section}>
          <Text className={classes.heading}>{t('terms.title')}</Text>
          <Text className={classes.subtitle}>{t('terms.intro')}</Text>

          <Box
            component="ul"
            className={classes.list}
          >
            {points.map((p, idx) => (
              <Box
                key={idx}
                component="li"
                className={classes.listItem}
              >
                <Text className={classes.textStyle1}>{p}</Text>
              </Box>
            ))}
          </Box>

          <Text className={classes.subtitle}>
            <strong>{liabilityTitle}</strong>
          </Text>
          <Text className={classes.paragraph}>{liabilityText}</Text>
        </Box>
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
